import { render, staticRenderFns } from "./Scrolltop.vue?vue&type=template&id=3219fc28"
import script from "./Scrolltop.vue?vue&type=script&lang=js"
export * from "./Scrolltop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports